/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import {ScheduledQuestionnaireInstanceCreateModel} from "../../models/scheduled-questionnaire-instance-create-model";

export interface ScheduledQuestionnaireInstancesPostParams {
    body?: ScheduledQuestionnaireInstanceCreateModel
}

export function scheduledQuestionnaireInstancePost(http: HttpClient, rootUrl: string, params?: ScheduledQuestionnaireInstancesPostParams, headers?: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(rootUrl, scheduledQuestionnaireInstancePost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    if (headers) {
        for (let headerKey of headers.keys()) {
            rb.header(headerKey, headers.get(headerKey));
        }
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<void>;
        })
    );
}

scheduledQuestionnaireInstancePost.PATH = '/api/v1/scheduled-questionnaires';
